import { initializeApp, type FirebaseApp } from 'firebase/app';
import { firebaseConfig, isConfigured } from './config';

/**
 * Initialisation paresseuse de l'app Firebase. Singleton sur la durée de vie
 * de l'onglet. Toute lecture passe par `getApp()` — si la config est absente,
 * retourne `null` et les services en aval (auth) doivent gérer le cas.
 *
 * `initializeApp()` est synchrone et ne fait pas de requête réseau, donc le
 * coût d'init est négligeable. Les modules `firebase/auth`, `firebase/firestore`
 * etc. sont importés à la demande dans leurs propres modules pour le
 * code-splitting.
 */

let cachedApp: FirebaseApp | null = null;

export function getApp(): FirebaseApp | null {
  if (!isConfigured()) return null;
  if (cachedApp !== null) return cachedApp;
  cachedApp = initializeApp(firebaseConfig);
  return cachedApp;
}
